import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  width: 100%;
  min-height: 100%;
  padding: 72px;
  overflow: scroll;

  background: #f1f4f5;
`;

export const Header = styled.div`
  margin-bottom: 32px;

  display: flex;
  justify-content: space-between;
`;

export const SearchControls = styled.div`
  margin-bottom: 48px;

  display: flex;
  justify-content: space-between;
`;

export const SearchControlsLeft = styled.div`
  gap: 16px;

  display: flex;
  justify-content: space-between;
`;

export const SearchControlsRight = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const PaginationContainer = styled.div`
  position: sticky;
  bottom: 0;

  width: 100%;
  padding: 16px;

  background-color: #fff;

  display: flex;
  justify-content: center;
  align-items: center;
`;
